import validate from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/nuxt/dist/pages/runtime/validate.js";
import my_45global from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/middleware/my.global.js";
import manifest_45route_45rule from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  my_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}